export default __webpack_public_path__ + "static/media/icon-person-info-male-desktop.ef911dfb.svg";